/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
// import { useStaticQuery, graphql } from "gatsby"
import { createGlobalStyle } from "styled-components"

// import Header from "./header"
import "./layout.css"
import { Colors } from "./../lib/misc.js"

const Layout = ({ children }) => {
  /*
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)
  */
  return (
    <>
      {children}
      <Global />
      <Global2 />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout

const Global = createGlobalStyle`
	body {
		background-color: ${Colors.background};
		color: ${Colors.text};
		font-family: "Varela Round", Helvetica Neue;
	}
	@font-face {
	  font-family: "Proxima Nova";
	  src: url("/static/fonts/proxima-nova-regular.ttf") format("truetype");
	}
`

const Global2 = createGlobalStyle`
	*,
	*::before,
	*::after {
	  -moz-osx-font-smoothing: grayscale;
	  -webkit-font-smoothing: antialiased;
	  text-rendering: optimizeLegibility;
	  box-sizing: border-box;
	  backface-visibility: hidden;
	}

	html {
	  width: 100%;
	  height: 100%;
	  font-size: 62.5%;
	  font-size: calc(1em * .625);
	}

	body {
	  position: relative;
	  width: 100%;
	  height: 100%;
	  margin: 0;
	  font-style: normal;
	  font-weight: 400;
	  font-size: 1.5rem;
	  line-height: 1.4;
	}

	/* Get rid of gap under images by making them display: inline-block; by default */
	img {
	  display: inline-block;
	  vertical-align: middle;
	  max-width: 100%;
		border: 0;
	}

	/* Remove Svg outline */
	svg {
	  outline: 0;
	}

	/* Reset <button> styles created by most browsers */
	button {
	  appearance: none;
	  padding: 0;
	  border: 0;
	  background: transparent;
	  outline: 0;
	  cursor: pointer;
	  line-height: 1;
	}

	ul,
	ol,
	dl,
	p,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
	  margin: 0;
	  padding: 0;
	  /* font-family: inherit; */
	  font-weight: 300;
	}

	b { font-weight: bold; }

	a {
    color: inherit;
    line-height: inherit;
    text-decoration: none;
    tap-highlight-color: transparent;
    cursor: pointer;
    &:hover,
    &:focus {
      text-decoration: none;
    }
  }

	#__next {
	  height: 100%;
	}
`
